import(/* webpackMode: "eager" */ "/vercel/path0/apps/magicsky/src/app/error.tsx");
